import { ENV } from '../config/constant';
import { axios } from '../config/axios';
const { VUE_APP_API_HOST_ZLZ: HOST } = ENV;

export function getOSS() {
  return axios.get(`${HOST}/oss/sts`);
}
/**
 * 获取minio配置
 */
export function GetMinio() {
  return axios.get(`${HOST}/minio/sts`);
}

/**
 *
 * @param {File} file 文件
 * @param {string} ObjectName 文件路径加名称
 */
export function UploadingFile(file, ObjectName) {
  const param = new FormData(); // 创建form对象
  param.append('file', file); // 通过append向form对象添加数据
  // const config = {
  //   headers: { 'Content-Type': 'multipart/form-data' }
  // };
  return axios.post(
    `${HOST}/repairRecord/upload?objectName=${ObjectName}`,
    param,
    {
      timeout: 10 * 60 * 1000
    }
  );
}
